import React from 'react';
import {
    FacebookShareButton,
    TwitterShareButton,
    LinkedinShareButton,
    TelegramShareButton,
    WhatsappShareButton,
    FacebookIcon,
    TwitterIcon,
    LinkedinIcon,
    TelegramIcon,
    WhatsappIcon,
} from 'react-share';

interface ShareButtonsProps {
    shareUrl: string;
    shareTitle: string;
}

const ShareButtons: React.FC<ShareButtonsProps> = ({ shareUrl, shareTitle }) => {
    return (
        <div className="share-section">
            <div className="share-buttons">
                <FacebookShareButton url={shareUrl}>
                    <FacebookIcon size={32} round/>
                </FacebookShareButton>
                <TwitterShareButton url={shareUrl} title={shareTitle}>
                    <TwitterIcon size={32} round/>
                </TwitterShareButton>
                <LinkedinShareButton url={shareUrl} title={shareTitle}>
                    <LinkedinIcon size={32} round/>
                </LinkedinShareButton>
                <TelegramShareButton url={shareUrl} title={shareTitle}>
                    <TelegramIcon size={32} round/>
                </TelegramShareButton>
                <WhatsappShareButton url={shareUrl} title={shareTitle}>
                    <WhatsappIcon size={32} round/>
                </WhatsappShareButton>
            </div>
        </div>
    );
};

export default ShareButtons; 